import ClickAwayListener from '@mui/material/ClickAwayListener';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import {
  parseISO,
  formatISO,
  isValid,
  isBefore,
  isAfter,
  format,
} from 'date-fns';
import { Box as MuiBox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { dateFnsLocales } from 'lib/utils/getDateFnsLocales';
import styled from 'styled-components';
import colors from 'lib/colors';
import Calendar from 'react-calendar';

const CalendarPopper = ({
  setIsCalendarOpen,
  filter,
  setFilter,
  setIsUsingCustomDate,
  setSelected,
}) => {
  const { i18n, t } = useTranslation();

  return (
    <ClickAwayListener onClickAway={() => setIsCalendarOpen(false)}>
      <SCalendarWrap>
        <MuiBox
          display="flex"
          justifyContent="space-between"
          marginBottom="10px"
          alignItems="center"
        >
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={dateFnsLocales[i18n.language]}
          >
            <DatePicker
              value={parseISO(filter.startDateTime)}
              slotProps={{
                textField: {
                  InputProps: {
                    className: 'input',
                    endAdornment: null,
                  },
                  sx: {
                    '& fieldset': {
                      '& legend': {
                        width: 'unset',
                      },
                    },
                  },
                },
              }}
              onChange={(value) => {
                if (isValid(value)) {
                  if (
                    isBefore(value, new Date('01-01-2100')) &&
                    isAfter(value, new Date('01-01-1920'))
                  ) {
                    setFilter((curr) => ({
                      ...curr,
                      startDateTime: formatISO(value),
                    }));
                    setIsUsingCustomDate(true);
                    setSelected(null);
                  }
                }
              }}
            />
            —
            <DatePicker
              value={parseISO(filter.endDateTime)}
              style={{ height: 40, width: 100 }}
              slotProps={{
                textField: {
                  InputProps: {
                    className: 'input',
                    endAdornment: null,
                  },
                  sx: {
                    '& fieldset': {
                      '& legend': {
                        width: 'unset',
                      },
                    },
                  },
                },
              }}
              onChange={(value) => {
                if (isValid(value)) {
                  if (
                    isBefore(value, new Date('01-01-2100')) &&
                    isAfter(value, new Date('01-01-1920'))
                  ) {
                    setFilter((curr) => ({
                      ...curr,
                      endDateTime: formatISO(value),
                    }));
                    setIsUsingCustomDate(true);
                    setSelected(null);
                  }
                }
              }}
            />
          </LocalizationProvider>
        </MuiBox>
        <SCalendar
          locale="en-En"
          selectRange
          minDate={new Date('01-01-1920')}
          maxDate={new Date('01-01-2100')}
          formatShortWeekday={(locale, date) => t(format(date, 'EEE'))}
          value={[new Date(filter.startDateTime), new Date(filter.endDateTime)]}
          onChange={(value) => {
            setFilter((curr) => ({
              ...curr,
              startDateTime: formatISO(value[0]),
              endDateTime: formatISO(value[1]),
            }));
            setIsUsingCustomDate(true);
            setSelected(null);
          }}
        />
      </SCalendarWrap>
    </ClickAwayListener>
  );
};

const SCalendarWrap = styled.div`
  && {
    background-color: ${colors.white};
    position: absolute;
    z-index: 20;
    top: 100%;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    width: fit-content;
    border: 1px solid ${colors.gray200};
    padding: 12px 16px;
    box-shadow: 0px 8px 16px -8px #00000033;
  }
`;

const SCalendar = styled(Calendar)`
  width: 350px;
  padding: 0;
  margin: 0;

  .react-calendar__navigation {
    padding: 0;
    gap: 5px;
    margin-bottom: 10px;
  }
  .react-calendar__month-view__weekdays {
    margin-bottom: 10px;
  }
  border: none;
`;

export default CalendarPopper;
